class NewsController {
  constructor($sce, DataService) {
    "ngInject";
    this.name = 'news';
    this.news = [];
    this.limit = 4;
    this.top = false;
    this.message = "";
    let self = this;

    DataService.getNews().then(function(response) {
      self.news = response.data;

      for(let i = 0; i < self.news.length; i++) {
        if(self.news[i].description.length > 800) {
          self.news[i].description = $sce.trustAsHtml(self.news[i].description.split('</p>')[0] + self.news[i].description.split('</p>')[1]);
        } else {
          self.news[i].description = $sce.trustAsHtml(self.news[i].description);
        }
      }
    });
  }

  showPost() {
    this.limit = this.news.description;
    this.top = true;
  }

  toTop() {
    $(window).scrollTop(0);
  }

  toggleMessage(type) {
    if(type == "article") {
      return "Read Full Article";
    } else if(type == "golf") {
      return "Register";
    } else {
      return "Learn More";
    }
  }

}

export default NewsController;



// WEBPACK FOOTER //
// ./app/components/news/news.controller.js